export { default, type ScreenReaderTextProps } from './ScreenReaderText';
